var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path, _circle13, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSpeakers = function SvgSpeakers(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137.21,
    y: 9.02,
    width: 335.09,
    height: 552.46,
    rx: 32,
    fill: "#f4abe0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 301.27,
    cy: 153.25,
    r: 75.36,
    fill: "#015e85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.27,
    cy: 152.12,
    r: 41.81,
    fill: "#f4abe0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.97,
    cy: 380.33,
    r: 108.52,
    fill: "#015e85"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.72,
    cy: 380.28,
    r: 65.79,
    fill: "#6e5f91"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.37,
    cy: 55.14,
    r: 12.08,
    fill: "#6e5f91"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.15,
    cy: 55.14,
    r: 12.08,
    fill: "#6e5f91"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.37,
    cy: 524,
    r: 12.08,
    fill: "#6e5f91"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.41,
    cy: 446.12,
    r: 7.28,
    fill: "#f7f3d6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.51,
    cy: 446.12,
    r: 7.28,
    fill: "#f7f3d6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.41,
    cy: 315.16,
    r: 7.28,
    fill: "#f7f3d6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.51,
    cy: 315.16,
    r: 7.28,
    fill: "#f7f3d6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.15,
    cy: 524,
    r: 12.08,
    fill: "#6e5f91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430.15 561.49l-6.81 22.86a11.39 11.39 0 0 1-10.92 8.14h-17.81a11.4 11.4 0 0 1-10.61-7.31l-9.09-23.69zM236.74 561.49l-6.82 22.86a11.38 11.38 0 0 1-10.92 8.14h-17.8a11.4 11.4 0 0 1-10.64-7.31l-9.09-23.69z",
    fill: "#015e85"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.88,
    cy: 380.34,
    r: 29.03,
    fill: "#f4abe0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M545.64 128.86a2.42 2.42 0 0 0 2.34-2.51 2.38 2.38 0 0 0-2.34-2.34c-2.15 0-21.53-.71-21.53-23.32a2.33 2.33 0 1 0-4.66 0c0 22.61-19.38 23.32-21.53 23.32h-.18a2.34 2.34 0 0 0-2.15 2.34 2.38 2.38 0 0 0 2.33 2.33c2.33 0 21.53.71 21.53 23.32a2.37 2.37 0 0 0 2.33 2.33 2.06 2.06 0 0 0 2.15-2.15c0-22.61 19.38-23.32 21.53-23.32z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeakers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speakers.57236c23.svg";
export { ForwardRef as ReactComponent };